import React from 'react';
import styled from 'styled-components';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/Input'. 'app/webpack/javascripts/shared/DEPRECATED/components/Input.js' implicitly has an 'any' type.
import Input from 'shared/DEPRECATED/components/Input';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/form/layout'. 'app/webpack/javascripts/shared/DEPRECATED/components/form/layout.js' implicitly has an 'any' type.
import { FormField } from 'shared/DEPRECATED/components/form/layout';
import { withLocalePrefix } from 'shared/utils/translation';
import Errors from '../../shared/errors';
import {
  ContentBody,
  ContentContainer,
  ContentDescription,
  ContentHeader,
  Required,
} from '../../components';

const PaddedContentBody = styled(ContentBody)`
  padding-top: 1em;
`;

type Props = {
  days: number | null | undefined;
  errors?: Array<string>;
  ruleId: number;
  onChange: any;
};

const t = withLocalePrefix(
  'gdpr.data_retention_rules.view.edit.retention_period'
);

export default function RetentionDays(props: Props) {
  const { errors, days, onChange, ruleId } = props;
  const errorComponent = errors && errors.length && <Errors errors={errors} />;
  return (
    <ContentContainer data-ref="data-retention-days-component">
      <ContentHeader>
        {t('header')}
        &nbsp;
        <Required />
      </ContentHeader>
      <FormField error={errorComponent}>
        <ContentDescription>{t('description')}</ContentDescription>
        <PaddedContentBody>
          <Input
            type="number"
            width="75px"
            value={days}
            // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
            onChange={(e) => {
              if (parseInt(e.target.value)) {
                onChange(parseInt(e.target.value));
              }
            }}
            data-provides="data_retention_period"
            data-provides-for={ruleId}
          />
          &nbsp; &nbsp;
          {t('days')}
        </PaddedContentBody>
      </FormField>
    </ContentContainer>
  );
}
